exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sync-loader[data-v-7af72728] {\n  display: inline-block;\n  background-color: #2b93ff;\n  border-radius: 50%;\n  width: 27px;\n  height: 27px;\n}\n.sync-loader svg[data-v-7af72728] {\n    margin-top: 3px;\n    margin-left: 2px;\n}\n.md-success[data-v-7af72728] {\n  cursor: default;\n}\n.sync-button[data-v-7af72728] {\n  display: inline-block;\n}\n", ""]);

// exports
